import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import AutocompleteInput from 'components/AutocompleteInput';
import apiFetch from 'utils/apiFetch';
import Likes from 'components/Steps/Likes';
import UsersModal from 'components/UsersModal';
import Bubble from './Bubble';
import ListOption from './ListOption';
import {
  ListWrapper, TagLabel, PrintUsers, TagsWrapper, CreatorMargin, ListStyled, Searcher,
} from './styles';

class List extends Component {
  constructor(props) {
    super(props);

    const { values, options } = props;
    const answers = [];
    const answersTags = [];

    _.forEach(values, (name) => {
      const item = _.find(options, (option) => {
        return option.name.trim() === name.trim();
      });
      if (item) {
        answers.push(item.id);
      } else {
        answersTags.push(name);
      }
    });

    this.state = {
      values: answers,
      viewUser: '',
      userClicked: null,
      createTags: answersTags.length > 0,
      tags: answersTags,
      addedOptions: [],
    };
  }

  componentDidUpdate(prevProps) {
    const { values } = this.props;
    const { values: prevValues } = prevProps;

    if (JSON.stringify(values) !== JSON.stringify(prevValues)) {
      this.setNewAnswers();
    }
  }

  setNewAnswers = () => {
    const { values, options } = this.props;
    const { addedOptions } = this.state;
    const answers = [];
    const answersTags = [];

    const finalOptions = options.concat(addedOptions);

    _.forEach(values, (name) => {
      const item = _.find(finalOptions, { name });
      if (item) {
        answers.push(item.id);
      } else {
        answersTags.push(name);
      }
    });

    this.setState({ values: answers, tags: answersTags });
  }

  handleCloseFeedbackUsers = () => {
    this.setState({ viewUser: '' });
  }

  connectWithElement = (id) => {
    const { narrativeType, options, stepId } = this.props;

    const option = _.find(options, { id });

    if (option) {
      
      const params = {
        narrativeType,
        type: option.type,
        name: option.name,
        stepId,
      };
      apiFetch('POST', { endPoint: 'elements/connection' }, params);
    }
  }

  disconnectFromElement = (id) => {
    const { narrativeType, options, stepId } = this.props;
    const { addedOptions } = this.state;

    const finalOptions = options.concat(addedOptions);

    const option = _.find(finalOptions, { id });

    if (option) {
      
      const params = {
        narrativeType,
        type: option.type,
        name: option.name,
        stepId,
      };
      apiFetch('DELETE', { endPoint: 'elements/connection' }, params);
    }
  }

  handleChangeAnswers = () => {
    const { onChangeAnswers, options } = this.props;
    const { values, addedOptions } = this.state;

    const finalOptions = options.concat(addedOptions);

    if (onChangeAnswers) {
      const answers = _.filter(finalOptions, option => values.includes(option.id));
      onChangeAnswers(_.map(answers, answer => answer.name));
    }
  }

  checkMaximumOptions = () => {
    const { maxAnswers } = this.props;
    const { values } = this.state;

    if (maxAnswers && values.length > maxAnswers) {
      do {
        if (values.length) {
          this.disconnectFromElement(values.shift());
        }
      } while (values.length > maxAnswers);
    }

    this.setState({ values });

    this.handleChangeAnswers();
  }

  onSelect = (id) => {
    const { values } = this.state;
    if (!values.includes(id)) {
      values.push(id);
    }
    this.connectWithElement(id);
    this.setState({ values }, this.checkMaximumOptions);
  }

  onUnselect = (id) => {
    const { values } = this.state;
    _.remove(values, element => (element === id));

    this.setState({ values }, this.checkMaximumOptions);

    
    this.disconnectFromElement(id);

    this.handleChangeAnswers();
  }

  getView = () => {
    const { options } = this.props;
    const maxLength = 8;
    let view = 'bubbles';
    _.forEach(options, (option) => {
      const length = option.name.length;
      if (length > maxLength) {
        view = 'list';
      }
    });
    return view;
  }

  showCreateOthers = () => {
    this.setState({ createTags: true });
  }

  hideCreateOthers = () => {
    this.setState({ createTags: false });
  }

  printTags = () => {
    const { tags } = this.state;

    return _.map(tags, (tag, index) => (<TagLabel key={index} onClick={this.removeTag}>{tag}</TagLabel>));
  }

  removeTag = (event) => {
    const { textContent: tag } = event.currentTarget;
    const { tags } = this.state;
    _.remove(tags, element => (element === tag));
    this.setState({ tags });
    this.disconnectTag(tag);
  }

  disconnectTag = (tag) => {
    const { narrativeType, type, stepId } = this.props;
    
    const params = {
      narrativeType,
      type,
      name: tag,
      stepId,
    };
    apiFetch('DELETE', { endPoint: 'elements/connection' }, params);
  }

  handleTag = (tag) => {
    const {
      type, narrativeType, options, stepId,
    } = this.props;
    const { tags, addedOptions, values } = this.state;

    if (!tags.includes(tag.name)) {
      
      const params = {
        narrativeType,
        type,
        name: tag.name,
        stepId,
      };
      apiFetch('POST', { endPoint: 'elements/connection' }, params);

      if (!values.includes(tag.id)) {
        values.push(tag.id);
      }

      if (!tags.includes(tag.name)) {
        tags.push(tag.name);
      }

      if (!_.find(addedOptions, { name: tag.name }) && !_.find(options, { name: tag.name })) {
        addedOptions.push(tag);
      }

      this.setState({ tags, addedOptions, values }, this.checkMaximumOptions);
    }
  }

  handleTagCreation = (tag) => {
    const { type } = this.props;
    this.handleTag({ ...tag, id: Math.round(Math.random() * 99999), type });
  }

  onSelectUser = (like) => {
    this.setState({ viewUser: 'profile', userClicked: like });
  }

  printSearcher() {
    const { literals, type } = this.props;
    const { tags } = this.state;
    return (
      <Searcher>
        <AutocompleteInput
          canCreateNew
          type={type}
          placeholder={literals.searchElementOrCreate}
          selectedOptions={tags}
          onSelectOption={this.handleTag}
          onCreateOption={this.handleTagCreation}
          onSelect={this.onSelect}
        />
      </Searcher>
    );
  }

  printUsers() {
    const { options, literals } = this.props;
    const { values } = this.state;

    let name = '';
    let users = [];

    _.forEach(values, (opt, index) => {
      const option = _.find(options, { id: opt });
      if (option) {
        name = name ? `${name} + ${option.name}` : option.name;
        users = index ? _.intersectionBy(users, option.users, 'id') : option.users;
      }
    });

    if (users.length) {
      return (
        <Likes
          userList={users}
          id={values[0]}
          label={`${literals.usersIn} ${name}`}
          onSelectUser={this.onSelectUser}
        />
      );
    }

    return null;
  }

  printSelectedUser() {
    const {
      viewUser, userClicked, values,
    } = this.state;
    const { options } = this.props;
    let users = [];

    _.forEach(values, (opt, index) => {
      const option = _.find(options, { id: opt });
      if (option) {
        users = index ? _.intersectionBy(users, option.users, 'id') : option.users;
      }
    });

    if (viewUser !== 'profile') {
      return null;
    }

    return (
      <UsersModal
        usersIds={_.map(users, user => user.id)}
        userSelected={userClicked}
        onEnd={this.handleCloseFeedbackUsers}
      />
    );
  }

  printOptions() {
    const {
      options, maxAnswers, type, actualContext,
    } = this.props;
    const { values, addedOptions } = this.state;
    const view = this.getView();
    const isSdg = type === 'sdg' || type === 'sdg_project' || type === 'investor_sdg_project' || type === 'user_sdg_project';

    const color = actualContext.color.color;

    if (isSdg) {
      const sdgOptions = options;
      return _.map(sdgOptions, (option) => {
        const selected = values.includes(option.id);
        switch (view) {
          case 'bubbles':
            return (<Bubble key={option.id} color={color} data={option} selected={selected} onSelect={this.onSelect} onUnselect={this.onUnselect} />);
          default:
            return (<ListOption key={option.id} color={color} data={option} selected={selected} onSelect={this.onSelect} onUnselect={this.onUnselect} maxAnswers={maxAnswers || options.length} />);
        }
      });
    }

    const optionsToRender = [...options];
    addedOptions.forEach((add) => {
      optionsToRender.push(add);
    });
    const currentOptions = _.map(optionsToRender, (option) => {
      const selected = values.includes(option.id);
      switch (view) {
        case 'bubbles':
          return (<Bubble key={option.id} color={color} data={option} selected={selected} onSelect={this.onSelect} onUnselect={this.onUnselect} />);
        default:
          return (<ListOption key={option.id} color={color} data={option} selected={selected} onSelect={this.onSelect} onUnselect={this.onUnselect} />);
      }
    });

    return (
      <div>
        {currentOptions}
      </div>
    );
  }

  printCreationOption() {
    const view = this.getView();
    const { literals } = this.props;
    const { createTags } = this.state;
    const data = {
      id: 0,
      name: literals.other,
    };
    switch (view) {
      case 'bubbles':
        return (<Bubble key='0' data={data} selected={createTags} onSelect={this.showCreateOthers} onUnselect={this.hideCreateOthers} />);
      default:
        return (<ListOption key='0' data={data} selected={createTags} onSelect={this.showCreateOthers} onUnselect={this.hideCreateOthers} />);
    }
  }

  printTagsCreation() {
    const { type, literals } = this.props;
    const { tags } = this.state;
    return (
      <TagsWrapper>
        <AutocompleteInput
          canCreateNew
          type={type}
          placeholder={literals.searchOrCreate}
          selectedOptions={tags}
          onSelectOption={this.handleTag}
          onCreateOption={this.handleTagCreation}
        />
        {
          this.printTags()
        }
        <CreatorMargin />
      </TagsWrapper>
    );
  }


  render() {
    const view = this.getView();
    const { showSearcher } = this.props;


    return (
      <React.Fragment>
        {showSearcher && this.printSearcher()}
        {this.printSelectedUser()}
        <ListStyled>
          <ListWrapper view={view}>
            {this.printOptions()}
            {}
            {}
          </ListWrapper>
          <PrintUsers>
            {this.printUsers()}
          </PrintUsers>
        </ListStyled>
      </React.Fragment>
    );
  }
}

List.propTypes = {
  options: PropTypes.array.isRequired,
  maxAnswers: PropTypes.number,
  canCreate: PropTypes.bool,
  showSearcher: PropTypes.bool,
  literals: PropTypes.object.isRequired,
  values: PropTypes.array,
  type: PropTypes.string,
  actualContext: PropTypes.object.isRequired,
  narrativeType: PropTypes.string,
  onChangeAnswers: PropTypes.func,
  stepId: PropTypes.number,
};

List.defaultProps = {
  maxAnswers: null,
  canCreate: false,
  showSearcher: false,
  values: [],
  type: '',
  narrativeType: '',
  onChangeAnswers: null,
  stepId: 0,
};

export default List;



// WEBPACK FOOTER //
// ./src/components/Steps/List/components/index.jsx